module.exports = __webpack_public_path__ + "static/media/shopify-logo.77ae335f.svg";